import { reduceReducers } from '../../../common/utils/reducer-utils';

import part from './part';
import robot from './robot';

export default reduceReducers(
  part,
  robot,
);
